import { useState } from "hono/jsx";
import { generateFarmName } from "@/features/rooms/lib/nameGenerator.ts";

interface ProfileNameEditorProps {
  initialName: string;
}

export function ProfileNameEditor({ initialName }: ProfileNameEditorProps) {
  const [name, setName] = useState(initialName);

  return (
    <form action="/profile/update-name" method="post" class="space-y-4">
      <div class="form-control w-full">
        <label class="label">
          <span class="label-text">Display Name</span>
        </label>
        <div class="flex gap-2">
          <input
            type="text"
            name="name"
            required
            class="input input-bordered w-full"
            value={name}
            onInput={(e) =>
              setName((e.currentTarget as HTMLInputElement).value)}
            maxLength={20}
          />
          <button
            type="button"
            class="btn btn-square btn-outline"
            onClick={() => setName(generateFarmName())}
            title="Generate Random Name"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </button>
        </div>
        <label class="label">
          <span class="label-text-alt opacity-60">
            This name will be used in all games.
          </span>
        </label>
      </div>

      <div class="card-actions justify-end">
        <button type="submit" class="btn btn-primary">Update Name</button>
      </div>
    </form>
  );
}
